import { render, staticRenderFns } from "./DownloadReport.vue?vue&type=template&id=4c79b0fe&scoped=true"
import script from "./DownloadReport.vue?vue&type=script&lang=ts"
export * from "./DownloadReport.vue?vue&type=script&lang=ts"
import style0 from "./DownloadReport.vue?vue&type=style&index=0&id=4c79b0fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c79b0fe",
  null
  
)

export default component.exports